import React from "react";

import { Link, useLocation } from "react-router-dom";




function Header() {
    const location = useLocation();
    
    const getLinkStyle = (path) => {
  return location.pathname === path
    ? {
        color: "#e87722",
      }
    : {};
};

  return (
    <div>
      <header class="ak-site_header ak-style1 ak-sticky_header">
        <div class="ak-main_header">
          <div class="container">
            <div class="ak-main_header_in">
              <div class="ak-main-header-left">
                <a class="ak-site_branding" href="/">
                  <img
                    src="./assets/img/about/logo3.PNG"
                    alt="..."
                    style={{ width: "120px", height: "90px" }}
                  />
                  <h6
                    style={{
                      fontSize: "10px",
                      marginLeft: "80px",
                      color: "green",
                    }}
                  >
                    Knowledge Wins
                  </h6>
                </a>
              </div>
              <div class="ak-main-header-center">
                <div class="ak-nav ak-medium">
                  <ul class="ak-nav_list">
                    <li>
                      <a href="/" style={getLinkStyle("/")}>Home</a>
                    </li>
                    <li>
                      <a href="/about" style={getLinkStyle("/about")}>
                        About
                        <br />
                      </a>
                    </li>
                    <li class="menu-item-has-children">
                      <a href="/">
                        Short Term <br />
                        Courses
                      </a>
                      <ul style={{ marginTop: "-20px", width: "400px" }}>
                        <li>
                          <li>
                            <a href="/basic" style={getLinkStyle("/basic")}>BASICS AND CONCEPTUAL COURSES</a>
                          </li>
                          <li>
                            <a href="/waferfab" style={getLinkStyle("/waferfab")}>WAFER FAB COURSES</a>
                          </li>
                          <li>
                            <a href="/packaging" style={getLinkStyle("/packaging")}>
                              SEMICONDUCTOR PACKAGING COURSES
                            </a>
                          </li>
                          <li>
                            <a href="/quality" style={getLinkStyle("/quality")}>QUALITY ASSURANCE COURSES</a>
                          </li>
                        </li>
                      </ul>
                      <span class="ak-munu_dropdown_toggle"></span>
                    </li>
                    <li class="menu-item-has-children">
                      <a href="/courses" style={getLinkStyle("/courses")}>
                        Semiconductor
                        <br />
                        Finishing Schools
                      </a>
                      <ul style={{ marginTop: "-20px" }}>
                        <li>
                          <li class="menu-item-has-children">
                            <a href="/manufacturing" style={getLinkStyle("/manufacturing")}>MANUFACTURING</a>
                            <ul>
                              <li>
                                <a href="/manufacturing" style={getLinkStyle("/manufacturing")}> WAFER FAB </a>
                              </li>
                              <li>
                                <a href="/osat" style={getLinkStyle("/osat")}>PACKAGING / OSAT / ATMP</a>
                              </li>
                              <li>
                                <a href="/feb" style={getLinkStyle("/feb")}>
                                  INTEGRATED WAFER FAB &amp; PACKAGING
                                </a>
                              </li>
                            </ul>
                            <span class="ak-munu_dropdown_toggle"></span>
                          </li>
                        </li>
                        <li>
                          <a href="/design" style={getLinkStyle("/design")}>DESIGN</a>
                        </li>
                      </ul>
                      <span class="ak-munu_dropdown_toggle"></span>
                    </li>
                    <li>
                      <a href="/nurturing" style={getLinkStyle("/nurturing")}>
                        Nurturing Wafer FAB
                        <br />
                        &amp; OSAT New Hires
                      </a>
                    </li>
                    <li class="menu-item-has-children">
                      <a href="/service" style={getLinkStyle("/service")}>
                        Semiconductor
                        <br />
                        Services
                      </a>
                      <ul style={{ marginTop: "-20px", width: "400px" }}>
                        <li>
                          <li>
                            <a href="/service" style={getLinkStyle("/service")}>
                              INDUSTRY CONSULTING, QUALITY MANAGEMENT SYSTEM
                              [QMS] SUPPORT
                            </a>
                          </li>
                           <li>
                            <a href="/service3" style={getLinkStyle("/service3")}>
                             EQUIPMENT REFURBISHMENT, UPGRADES

                            </a>
                          </li>
                          <li>
                            <a href="/service1" style={getLinkStyle("/service1")}>
                              TRUSTED ADVISORY AND MENTOR IN ESDM
                            </a>
                          </li>
                          
                          <li>
                            <a href="/service2" style={getLinkStyle("/service2")}>
                              ENABLING TAIWAN BASED SUPPORT TO GROW INDIA’S
                              SEMICONDUCTOR, ESDM ECOSYSTEM
                            </a>
                          </li>
                        </li>
                      </ul>
                      <span class="ak-munu_dropdown_toggle"></span>
                    </li>
                    <li>
                      <a href="/leadership" style={getLinkStyle("/leadership")}>Leadership</a>
                    </li>
                    <li>
                      <a href="/contact" style={getLinkStyle("/contact")}>Contact</a>
                    </li>
                  </ul>
                  <span class="ak-munu_toggle">
                    <span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="nav-bar-border"></div>
      </header>
    </div>
  );
}

export default Header;
